var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPageRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8448",
    "data-name": "Caminho 8448",
    d: "M7.712,7.144l-6.034,5.59a1.038,1.038,0,0,1-1.39,0,.864.864,0,0,1,0-1.287L5.627,6.5.288,1.554a.864.864,0,0,1,0-1.287,1.039,1.039,0,0,1,1.39,0l6.034,5.59a.864.864,0,0,1,0,1.287Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPageRight);
export default __webpack_public_path__ + "static/media/arrowPageRight.49199cf03e07e2a559574ed28291b085.svg";
export { ForwardRef as ReactComponent };